import util from "../../../util/util";
import { setTimeout } from "timers";
const moment = require("moment");

export default {
  name: "FeedbackBox",
  data() {
    return {
      feedbackMessage: "",
      isEmpty: true,
      messages: []
    };
  },
  props: {
    messagesData: {
      default: () => []
    },
    currentUserType: {
      default: () => {
        return {
          key: "sender",
          value: "interior"
        };
      }
    },
    isAdminPage: {
      default: false
    },
    currentUserName: {
      default: "User"
    },
    scrollable: {
      default: false
    },
    hasPrint: {
      default: true
    },
    readOnly: {
      default: false
    },
    hasPresend: {
      default: false
    },
    textField: {
      default: "text"
    },
    dateField: {
      default: "messageDate"
    },
    nameField: {
      default: "userName"
    },
    fromFeedback: false,
    fromVisa: false,
    fromOrder: false,
    showTip: true
  },
  filters: {
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    }
  },
  methods: {
    filterMessage(val) {
      if (this.fromOrder || this.fromFeedback) {
        this.feedbackMessage = val.replace(
          /[^a-z\u0430-\u044f0-9- !@#$%^*()_{}"':;?<>,~`=&\.\+\\\|\/\n]/gim,
          ""
        );
        this.$refs.messageInput.currentValue = this.feedbackMessage;
      }
    },
    messageSaved() {
      let data = this.preSend();
      this.messages.push(data);
      this.feedbackMessage = "";
    },
    messagesLoaded() {
      let messages = [];
      this.messagesData.forEach(i => {
        let item = Object.assign({}, i);
        const re = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/g;
        item[this.textField] = item[this.textField].replace(
          re,
          '<a href="$1" target="blank">$1</a>'
        );
        item[this.textField] = item[this.textField].replace(/\n/g, "<br/>");
        messages.push(item);
      });
      // this.messages = this.messagesData
      this.messages = messages;
      this.scrollMassagesToBottom();
    },
    scrollMassagesToBottom() {
      setTimeout(() => {
        let objDiv = document.getElementById("messagesBox");
        objDiv.scrollTop = objDiv.scrollHeight;
      }, 100);
    },
    showSaveError() {
      this.$alert(this.$t("feedback_saving_error"), "", {
        confirmButtonText: "OK"
      });
    },
    messageHandle() {
      if (this.hasPresend) {
        this.preSend();
      }
      this.$emit("submit", this.feedbackMessage);
      this.feedbackMessage = "";
    },
    getCurrentUser(data) {
      return data[this.currentUserType.key] === this.currentUserType.value;
    },
    preSend() {
      this.feedbackMessage = this.feedbackMessage.replace(/<[^>]+>/g, "");
      this.feedbackMessage = this.feedbackMessage.replace(/\n/g, "<br/>");

      let data = {
        [this.nameField]: this.currentUserName,
        [this.currentUserType.key]: this.currentUserType.value,
        [this.dateField]: moment(),
        [this.textField]: this.feedbackMessage
      };

      this.messages.push(data);
      this.scrollMassagesToBottom();

      return data;
    },
    changeLongWords(val) {
      let w = util.getWidthWindow();
      if (w > 1180) {
        w = 1180;
      }
      let str = "=".repeat(Math.ceil(w * 0.08));
      return val.replace(new RegExp(str, "gi"), `${str}<br/>`);
    }
  },

  watch: {
    feedbackMessage(val) {
      this.$emit("input", val);
      this.isEmpty = !val.length;
      if (this.isEmpty) {
        this.$emit("empty");
      }
    },
    messagesData: {
      handler: function () {
        this.messagesLoaded();
      },
      deep: true
    }
  },

  created() {
    this.messagesLoaded();
  }
};
